import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomToastService {
  private toastSubject = new BehaviorSubject<{ message: string, show: boolean, type: 'success' | 'info' | 'error' }>({
    message: '',
    show: false,
    type: 'success'
  });

  toast$ = this.toastSubject.asObservable();

  show(message: string, duration: number = 3000, type: 'success' | 'info' | 'error' = 'success') {
    this.toastSubject.next({ message, show: true, type });
    setTimeout(() => this.hide(), duration);
  }

  hide() {
    this.toastSubject.next({ message: '', show: false, type: 'success' });
  }
}
